<template lang="pug">
  div(class="block")
    div(class="title")
      div
        | 地方別
        br
        span プロジェクト掲載
        br
        span 市区町村数
      icon
    div(class="graph")
      img(
        src="~images/Event/Infographics/project_area_by_region@2x.png",
        class="image",
        :active="show",
      )
    div
      img(
        src="~images/Event/Infographics/project_area_by_region_index@2x.png",
        class="index",
      )
</template>
<script>
  import DataTitle from 'modules/components/Event/Infographics/DataTitle.vue';
  import Icon from 'images/Event/Infographics/pin.svg';
  import EventListener from 'modules/mixins/eventListener';

  export default {
    components: {
      DataTitle,
      Icon,
    },
    mixins: [EventListener],
    data() {
      return {
        show: false,
      };
    },
    mounted() {
      this.$listen(window, 'scroll', () => {
        const { innerHeight } = window;
        const { top } = this.$el.getBoundingClientRect();
        if (innerHeight > top + 200) {
          this.show = true;
        }
      });
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .title {
    position: relative;
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.2;
    color: $c-pink-dark;
    margin-left: 10%;
    span {
      font-size: 1.33em;
    }
    svg {
      position: absolute;
      top: -50%;
      left: -9%;
      fill: #fff;
      width: 90px;
      height: auto;
      z-index: 0;
    }
    > div {
      position: relative;
      z-index: 1;
    }
    @include mq('sm') {
      font-size: 2.4rem;
      margin-left: 12%;
      svg {
        width: 110px;
      }
    }
    @include mq {
      font-size: 3rem;
      margin-left: 15%;
      svg {
        width: 130px;
      }
    }
  }
  .block {
    padding-top: 100px;
  }
  .graph {
    position: relative;
    max-width: 906px;
    width: 100%;
    margin-top: 2%;
    margin-left: auto;
    margin-right: auto;
    @include mq('sm') {
      padding-left: 20px;
      padding-right: 20px;
      margin-top: -10%;
    }
  }
  .image {
    width: 100%;
    height: auto;
    transform: translateY(30%);
    opacity: 0;
    transition: transform 1s, opacity 1s;
    &[active] {
      transform: translateY(0);
      opacity: 1;
    }
  }
  .index {
    max-width: 264px;
    width: 100%;
    height: auto;
    margin-left: 100%;
    transform: translate(-110%, -180%);
    @include mq('sm') {
      max-width: 331px;
      transform: translate(-120%, -220%);
    }
  }
</style>
